import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import React from 'react'

import { useLogEvent } from '~/hooks/useLogEvent'

type RowDisplayToggleSubItem<RowId extends number | string> = {
  id: RowId
  isVisible: boolean
  label: string
}

export type RowDisplayToggleFormSubItemProps<RowId extends number | string> = {
  onChange?: (value: boolean, ids: RowId[]) => void
  subItem: RowDisplayToggleSubItem<RowId>
}

export const RowDisplayToggleFormSubItem = <RowId extends number | string>({
  onChange,
  subItem,
}: RowDisplayToggleFormSubItemProps<RowId>) => {
  const logEvent = useLogEvent()

  const handleChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      onChange?.(event.value, [subItem.id])

      logEvent('Turn onoff', { withAnalysisName: true, withSuffix: true })
    },
    [logEvent, onChange, subItem.id],
  )

  return (
    <Checkbox
      checked={subItem.isVisible}
      label={subItem.label}
      onChange={handleChange}
    />
  )
}
